import { Badge } from "@tellescope/design-system";
import type { CSSProperties } from "react";

interface SecondaryProductBadgeProps {
  label: string;
  className?: string;
}

/**
 * Secondary badge (e.g. "Popular", "Recommended for you") with the prototype's brand tints.
 * TODO(badge-tint-tokens): these hex tints are hardcoded — no design-system token covers
 * per-badge brand-color variants yet. Migrate to real tokens once they're added.
 */
export const SecondaryProductBadge = ({ label, className }: SecondaryProductBadgeProps) => {
  const tint = label === "Popular" ? "#8B728E" : label === "Recommended for you" ? "#75B9BE" : null;
  const style: CSSProperties = tint
    ? { backgroundColor: `color-mix(in oklab, ${tint} 16%, white)`, color: tint }
    : { backgroundColor: "hsl(var(--primary) / 0.1)", color: "hsl(var(--primary))" };

  return (
    <Badge className={className} style={style}>
      {label}
    </Badge>
  );
};
